<template>
  <div class="john-deerling slide">
    <HorizontalAnimation :animation="animation" :loop=false />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">STORE 0111</p>
      <h1>John Deerling</h1>
      <p>API partners with National to identify the driver and renter of the vehicle as <strong>John Deerling</strong>. API obtains a photo ID of Deerling via the DMV.</p>
    </div>
    <router-link to="/bolo">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import JohnDeerling from '@/assets/john-deerling.js'

export default {
  name: 'john-deerling',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: JohnDeerling
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top: 40px;
  }
</style>
